import React from 'react';
import {HulpiaTitle, HulpiaArchitecten, HulpiaSubTitle} from '../static/styles/styles'

const HulpiaArchitectenComp = () => <HulpiaArchitecten>
        <HulpiaTitle>HULPIA</HulpiaTitle>
        <HulpiaSubTitle>architecten</HulpiaSubTitle>
    </HulpiaArchitecten>


export default HulpiaArchitectenComp;


// WEBPACK FOOTER //
// ./src/componenten/HulpiaArchitectenComp.js